module.exports = __webpack_public_path__ + "static/media/backArrow.94e17a0c.svg";